/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SyncPatients/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import Empty from './Empty/index'
import Error from './Error/index'
import Loading from './Loading/index'
import No from './No/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import TysiaIconKeyboardArrowLeftFilled from 'DesignSystem/Svgs/TysiaIconKeyboardArrowLeftFilled/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function SyncPatients({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/IntegrationsApplications/Content/SyncPatients"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let constantData = 'Back to'
let tabSelectedTitleValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.title',
})
let aggregateData = fromAggregate.join(constantData, tabSelectedTitleValueData)
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<div
  data-testid="SyncPatients.Vertical"
  data-view-path={viewPath}
 style={{'--pl-1-2q6sPk': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-2-2q6sPk': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pt-3-2q6sPk': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pb-4-2q6sPk': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 size="small"
 type="ghost"
 onClick={onClick}
>
{childProps => (
<React.Fragment>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconKeyboardArrowLeftFilled
{...childProps}
  viewPath={`${viewPath}/TysiaIconKeyboardArrowLeftFilled`}
/>
)}
</TysiaButtonIcon>
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 data="'Back to'"
 data="tab.selected.title"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
</React.Fragment>
)}
</TysiaButton>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 weight="semibold"
 marginTop={dtSpaceM}
 level="h2"
 text="Sync patient records"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 size="xmedium"
 color={dtColorsNeutral500}
 text="Sync patients between Greyfinch and 3rd party app"
/>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 theme="light"
 marginTop={dtSpaceM}
 marginBottom={dtSpaceL}
/>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Loading'}>
<Loading
  viewPath={`${viewPath}/Loading`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Error'}>
<Error
  viewPath={`${viewPath}/Error`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Empty'}>
<Empty
  viewPath={`${viewPath}/Empty`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}